


export interface ItemStats {
	materialId?: string | null,
	materialName?: string | null,

	// Order details
	orderOriginalCount?: number | null,
	orderCount?: number | null,
	orderCountReducedPpas: boolean,
	orderCountReducedCustomer: boolean,

	orderOriginalVolume?: number | null,
	orderVolume?: number | null,
	orderVolumeReducedPpas: boolean,
	orderVolumeReducedCustomer: boolean,
	orderReasonCodes: string[],
	itemDirection?: ItemDirectionType | null,

	// Delivery details
	deliveryCount?: number | null,
	deliveryCountReducedPpas: boolean,
	deliveryCountReducedCustomer: boolean,

	deliveryVolume?: number | null,
	deliveryVolumeReducedPpas: boolean,
	deliveryVolumeReducedCustomer: boolean,
	deliveryReasonCodes: string[],

	deliveredCount?: number | null,
	deliveredCountReducedPpas: boolean,
	deliveredCountReducedCustomer: boolean,

	deliveredVolume?: number | null,
	deliveredVolumeReducedPpas: boolean,
	deliveredVolumeReducedCustomer: boolean,
	deliveredReasonCodes: string[],

	comment?: string | null,
}


export enum ItemDirectionType {
	toSale = 'ToSale',
	toReturn = 'ToReturn',
	suggestToReturn = 'SuggestToReturn',
}